<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-6">
        <div class="card h-100 mb-4 shadow-none border">
          <div class="card-header pb-0 px-3">
            <div class="row">
              <div class="col-md-6">
                <h6 class="mb-0">Ofertas Disponibles</h6>
              </div>
              <div class="col-md-6 d-flex justify-content-end align-items-center">
                <soft-input
                  v-model="searchQuery"
                  placeholder="Buscar oferta..."
                  icon="fas fa-search"
                  iconDir="left"
                  size="sm"
                  class="mb-0"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-4 p-3">
            <div class="table-responsive p-0" style="max-height: 500px">
              <table class="table align-items-center mb-0 jobs-table">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-job">Compañía / Cargo</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2 col-location">Ubicación</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-action">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in filteredJobs" :key="index">
                    <td class="col-job">
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center job-content">
                          <h6 class="mb-0 text-sm">{{ getJobName(item) }}</h6>
                          <p class="text-xs text-secondary mb-0">{{ getJobDescription(item) }}</p>
                        </div>
                      </div>
                    </td>
                    <td class="col-location">
                      <p class="text-xs font-weight-bold mb-0 job-location-text">{{ getJobLocation(item) }}</p>
                    </td>
                    <td class="align-middle text-center col-action">
                      <soft-button
                        color="success"
                        variant="outline"
                        size="sm"
                        class="mb-0 py-1 px-3"
                        :disabled="loading || isAssigned(item._id)"
                        @click="assignJob(item._id)"
                      >
                        <i class="fas fa-plus me-1"></i> {{ isAssigned(item._id) ? 'Asignado' : 'Asignar' }}
                      </soft-button>
                    </td>
                  </tr>
                  <tr v-if="filteredJobs.length === 0">
                    <td colspan="3" class="text-center py-4">
                      <p class="text-xs text-secondary mb-0">No se encontraron ofertas disponibles</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card h-100 mb-4 shadow-none border">
          <div class="card-header pb-0 px-3">
            <h6 class="mb-0">Ofertas Asignadas al Usuario</h6>
          </div>
          <div class="card-body pt-4 p-3">
            <soft-alert v-if="assignedJobs.length === 0" color="info" icon="fas fa-info-circle">
              El usuario aún no tiene ofertas asignadas
            </soft-alert>
            <div v-else class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Compañía</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Ubicación</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in assignedJobs" :key="index">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ item.name || 'Cargando...' }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">{{ item.location || '---' }}</p>
                    </td>
                    <td class="align-middle text-center">
                      <soft-button
                        color="danger"
                        variant="outline"
                        size="sm"
                        class="btn-icon-only shadow-none mb-0"
                        title="Eliminar asignación"
                        :disabled="loading"
                        @click="unassignJob(item._id)"
                      >
                        <i class="fas fa-trash"></i>
                      </soft-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, post } from "@/utils/httpRequest";
import Swal from "sweetalert2";
import SoftButton from "@/components/SoftButton.vue";
import SoftInput from "@/components/SoftInput.vue";
import SoftAlert from "@/components/SoftAlert.vue";

export default {
  name: "tabJobs",
  components: {
    SoftButton,
    SoftInput,
    SoftAlert
  },
  data: () => ({
    user_id: null,
    allJobs: [],
    assignedJobs: [],
    searchQuery: "",
    loading: false
  }),
  computed: {
    filteredJobs() {
      if (!this.searchQuery) return this.allJobs;
      const query = this.searchQuery.toLowerCase();
      return this.allJobs.filter(j => 
        (j.name && j.name.toLowerCase().includes(query)) ||
        (j.description && j.description.toLowerCase().includes(query)) ||
        (j.location && j.location.toLowerCase().includes(query))
      );
    }
  },
  mounted() {
    this.user_id = this.$route.query.id
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        // Obtenemos todas las ofertas
        const resJobs = await get('job-offers?limit=1000');
        this.allJobs = resJobs.data.docs || resJobs.data || [];

        // Obtenemos las ofertas asignadas usando el nuevo endpoint
        const resAssigned = await get(`job-offers/get-assigned-jobs?user_id=${this.user_id}`);
        
        // El backend devuelve el documento de asignación con job_ids poblado
        // Estructura probable: { user_id: ..., job_ids: [ { _id, name, ... }, ... ] }
        if (resAssigned.data && resAssigned.data.job_ids) {
          this.assignedJobs = resAssigned.data.job_ids;
        } else {
          this.assignedJobs = [];
        }
      } catch (error) {
        console.error("Error al cargar datos:", error);
      } finally {
        this.loading = false;
      }
    },
    isAssigned(jobId) {
      return this.assignedJobs.some(j => (j._id || j) === jobId);
    },
    getJobName(job) {
      return job?.detalles_oferta?.nombre_cargo || job?.name || 'Sin nombre';
    },
    getJobDescription(job) {
      const description = job?.description || job?.detalles_oferta?.tipo_empleo || '';
      return description ? description.substring(0, 50) + (description.length > 50 ? '...' : '') : '';
    },
    getJobLocation(job) {
      return job?.detalles_oferta?.ubicacion_cargo || job?.location || '---';
    },
    async assignJob(jobId) {
      this.loading = true;
      try {
        await post("job-offers/assign", { user_id: this.user_id, job_ids: [jobId] });
        Swal.fire({
          icon: 'success',
          title: 'Asignado',
          text: 'La oferta ha sido asignada correctamente',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000
        });
        await this.fetchData();
      } catch (error) {
        Swal.fire('Error', 'No se pudo asignar la oferta', 'error');
      } finally {
        this.loading = false;
      }
    },
    async unassignJob(jobId) {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: "Se eliminará el acceso del usuario a esta oferta",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#82d616',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        this.loading = true;
        try {
          await post("job-offers/unassign", { user_id: this.user_id, job_ids: [jobId] });
          Swal.fire({
            icon: 'success',
            title: 'Eliminado',
            text: 'Asignación eliminada correctamente',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000
          });
          await this.fetchData();
        } catch (error) {
          Swal.fire('Error', 'No se pudo eliminar la asignación', 'error');
        } finally {
          this.loading = false;
        }
      }
    }
  }
}
</script>

<style scoped>
.table thead th {
  padding: 0.75rem 1.5rem;
}
.table tbody td {
  padding: 0.75rem 1.5rem;
}

.jobs-table {
  width: 100%;
  table-layout: fixed;
}

.col-job {
  width: 50%;
}

.col-location {
  width: 20%;
}

.col-action {
  width: 30%;
  min-width: 140px;
}

.job-content,
.col-action {
  overflow-wrap: anywhere;
}

.job-location-text {
  white-space: normal;
  word-break: break-word;
  line-height: 1.35;
}

.col-action .btn {
  white-space: nowrap;
}

@media (max-width: 992px) {
  .col-job {
    width: 45%;
  }

  .col-location {
    width: 20%;
  }

  .col-action {
    width: 35%;
  }

  .table thead th,
  .table tbody td {
    padding: 0.75rem;
  }
}
</style>
